module.exports = __webpack_public_path__ + "static/Intenso-49702bbae5fa1b7eaf6915fc76e44c83.svg";